import { currentRuntime, isFeatureEnabled } from './index';
import type { FeatureKey, RuntimeFeatureFlags } from './types';

const WIDGET_FEATURE_KEYS: Partial<Record<string, FeatureKey>> = {
  holdTimeAnalysis: 'aiCoach',
};

export function getWidgetFeatureKey(widgetId: string): FeatureKey | null {
  return WIDGET_FEATURE_KEYS[String(widgetId || '').trim()] ?? null;
}

export function isWidgetEnabled(widgetId: string, features: RuntimeFeatureFlags = currentRuntime.features): boolean {
  const featureKey = getWidgetFeatureKey(widgetId);
  if (!featureKey) return true;
  return isFeatureEnabled(features, featureKey);
}

export function filterEnabledWidgetIds(widgetIds: string[], features: RuntimeFeatureFlags = currentRuntime.features): string[] {
  return widgetIds.filter((widgetId) => isWidgetEnabled(widgetId, features));
}
